import { Link } from "react-router-dom";

import styles from "./Topbar.module.css";

import { ChevronLeftIcon } from "@/components/icons";
import { ThemeToggle } from "@/components/ThemeToggle";
import { UserMenu } from "@/components/UserMenu";
import { useTopbarBackLink } from "@/hooks/useTopbarBack";

/**
 * The page header: a centred page title, the active page's "back" call-to-action
 * on the left (registered by pages via `useTopbarBack`), and global actions
 * (theme, account) on the right. Title is supplied by AppShell from the active
 * route; the left and right columns are equal width so the title stays centred.
 */
export function Topbar({ title }: { title: string }) {
  const back = useTopbarBackLink();

  return (
    <header className={styles.topbar}>
      <div className={styles.lead}>
        {back && (
          <Link to={back.to} className={styles.backLink}>
            <ChevronLeftIcon className={styles.backIcon} />
            <span className={styles.backLabel}>{back.label}</span>
          </Link>
        )}
      </div>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.actions}>
        <ThemeToggle />
        <UserMenu />
      </div>
    </header>
  );
}
